import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import LayoutNavbar from 'shared/layouts/LayoutNavbar';
import LayoutSidebar from 'shared/layouts/LayoutSidebar';
import ImpersonationBanner from 'shared/layouts/ImpersonationBanner';
import BeSafeContainer from 'components/commons/BeSafeContainer';
import ConfirmDialog from 'components/ConfirmDialog';

import { SidebarDataProvider } from 'contexts/SidebarDataContext';
import { ProfileProvider } from 'contexts/ProfileContext';

const Layout = (props) => {
  const intl = useIntl();

  const { showSidebarSecondary, concurrentUsersExceeded } = useSelector(
    ({ configuration }) => ({
      showSidebarSecondary: configuration.secondarySidebar,
      concurrentUsersExceeded: configuration.concurrentUsersExceeded,
    }),
    shallowEqual
  );

  const isImpersonating = useSelector(({ auth }) => !!auth.impersonator);

  const concurrentUsersExceededModal = (
    <BeSafeContainer visible={concurrentUsersExceeded}>
      <ConfirmDialog
        title={intl.formatMessage({
          id: 'GENERAL.WARNING',
        })}
        description={intl.formatMessage({
          id: 'REMOTE_ACCESS.CONCURRENT_USERS_WARNING',
        })}
        okLabel={intl.formatMessage({
          id: 'GENERAL.OK',
        })}
      />
    </BeSafeContainer>
  );

  return (
    <SidebarDataProvider>
      <ProfileProvider>
        <div className={showSidebarSecondary ? 'sidebar-expanded' : ''}>
          {concurrentUsersExceededModal}

          <div className="menu-navbar">
            <LayoutSidebar {...props} />
          </div>
          <div
            className={`content-layout${
              isImpersonating ? ' has-impersonation-banner' : ''
            }`}
          >
            <ImpersonationBanner />
            <div className="content-layout-header">
              <LayoutNavbar {...props} />
            </div>
            <div className="content-layout-body">
              {React.cloneElement(props.children, {
                user: props.user,
              })}
            </div>
          </div>
        </div>
      </ProfileProvider>
    </SidebarDataProvider>
  );
};

export default Layout;
